import type { FlagSet } from '../interfaces/flag-set.interface';
import { Flag } from './flag.enum';

export const DefaultFlagSet: FlagSet = {
  [Flag.LD_PROGRESSIVE_DISCLOSURE]: '',
  [Flag.LD_EMEA_DATA_BANNER_VISIBLE]: false,
  [Flag.LD_USE_FRAUD_PLATFORM_SERVICE]: false,
  [Flag.LD_MAINTENANCE_FLAG]: '',
  [Flag.LD_SIGNUP_WIDGET]: false,
  [Flag.LD_MCP_CONNECTOR_SIGNUP_FLOW]: false,
  [Flag.LD_EMAIL_BUILDER_SIGNUP]: false,
};
